module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6cfa64a624fd2abf7415cde5ed097746.png";